/**
* @name: xm-img-upload
* @author: weiyong
* @date: 2023-03-03 10:55
* @description：xm-img-upload
* @update: 2023-03-03 10:55
*/
<template>
  <div @click="showImgSel"
       class="ant-upload xm-img-select-system ant-upload-select ant-upload-select-picture-card"
       :class="disabled?'disabled':'noDisabled'"
       >
    <div style="padding-top: 20px;position: absolute;width: 100%;text-align: center;">
      <plus-outlined/>
    </div>
    <div  class="ant-upload" role="button" style="margin-top: 12px;">
      <div class="ant-upload-text">{{t('选择系统图')}}</div>
    </div>

    <xm-img-sel-modal @setSelImg="setSelImg" v-model:visible="visible"/>

  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import {useImgSelHook} from "@/components/fileCtl/hooks/useImgSelHook";
import XmImgSelModal from "@/components/fileCtl/xm-img-sel-modal.vue";
import {PlusOutlined} from "@ant-design/icons-vue";

const {t} = useI18n();
const loading = ref<boolean>(false);
const imageUrl = ref<string>('');



interface propTypes {
  disabled:boolean,
  businessId:string
}

const props = withDefaults(defineProps<propTypes>(), {
  disabled:false,
  businessId:''
})
const {showImgSel,visible}=useImgSelHook(props);

const emits = defineEmits(['setSelImg']);
/**
 * 设置选择的图片
 * @param activeKey
 */
const setSelImg=function ({activeKey}){
  emits('setSelImg',{activeKey});
}

//重置img的值
const reset = () => {
  imageUrl.value = '';
}
defineExpose({reset})

</script>

<style type="text/css" lang="less">
.ant-upload{
  &.disabled{
    cursor: not-allowed;
  }
}
.xm-img-select-system{
  position: relative;
}

</style>